/* eslint-disable */
import { Component, inject } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { DatePipe } from "@angular/common";
import { TooltipModule } from "primeng/tooltip";
import { TranslateService } from "@ngx-translate/core";
import { checkContractEnd } from "@shared/utils/date";

@Component({
  selector: "app-companies-contract-end-date",
  template: `
    <div
      tooltipPosition="top"
      [innerHtml]="cellValue"
      class="d-flex justify-content-center"
      [pTooltip]="
        checkContractEnd(paramsValue)
          ? _translateService.instant('MAIN_COMPANY.CONTRACT_END_DATE_WARNING')
          : null
      "
    ></div>
  `,
  imports: [TooltipModule],
  providers: [DatePipe],
  standalone: true,
})
export class CompaniesContractEndDateComponent
  implements ICellRendererAngularComp
{
  protected datePipe = inject(DatePipe);
  protected _translateService = inject(TranslateService);

  public cellValue: unknown;
  public paramsValue: any;

  agInit(params: ICellRendererParams): void {
    this.cellValue = this.getValueToDisplay(params);
  }

  getValueToDisplay(params: ICellRendererParams) {
    if (!params.value) {
      return "";
    } else {
      this.paramsValue = params.value;

      const contractEndDate = <string>(
        this.datePipe.transform(params.value, "dd.MM.yyyy")
      );

      return `${
        checkContractEnd(params.value)
          ? `<b class="text-danger">${contractEndDate}</b>`
          : `<span>${contractEndDate}</span>`
      }`;
    }
  }

  refresh() {
    return false;
  }

  protected readonly checkContractEnd = checkContractEnd;
}
